<template>
  <div class="card p-6 m-6">
    <p class="card-title">מעסיקים - חודש אחרון</p>
    <div class="card-content">
      <div v-if="loading" class="has-text-centered">
        <p>טוען נתונים...</p>
      </div>
      <div v-else-if="employers && employers.length > 0">
        <table class="table is-fullwidth is-striped">
          <thead>
            <tr>
              <th class="sortable-header" @click="sortBy('company_name')">
                שם החברה
                <span v-if="sortField === 'company_name'" class="sort-indicator">
                  {{ sortDirection === 'desc' ? '↓' : '↑' }}
                </span>
              </th>
              <th class="sortable-header" @click="sortBy('days_since_last_phone_call')">
                ימים מאז שיחת טלפון אחרונה
                <span v-if="sortField === 'days_since_last_phone_call'" class="sort-indicator">
                  {{ sortDirection === 'desc' ? '↓' : '↑' }}
                </span>
              </th>
              <th class="sortable-header" @click="sortBy('phone_calls_count')">
                מספר שיחות טלפון
                <span v-if="sortField === 'phone_calls_count'" class="sort-indicator">
                  {{ sortDirection === 'desc' ? '↓' : '↑' }}
                </span>
              </th>
              <th class="sortable-header" @click="sortBy('submissions_count')">
                כמות שליחות
                <span v-if="sortField === 'submissions_count'" class="sort-indicator">
                  {{ sortDirection === 'desc' ? '↓' : '↑' }}
                </span>
              </th>
              <th class="sortable-header" @click="sortBy('exposed_count')">
                מועמדים שנחשפו
                <span v-if="sortField === 'exposed_count'" class="sort-indicator">
                  {{ sortDirection === 'desc' ? '↓' : '↑' }}
                </span>
              </th>
              <th class="sortable-header" @click="sortBy('company_familiar_count')">
                מועמדים שעברו לסטטוס מוכר
                <span v-if="sortField === 'company_familiar_count'" class="sort-indicator">
                  {{ sortDirection === 'desc' ? '↓' : '↑' }}
                </span>
              </th>
              <th class="sortable-header" @click="sortBy('offer_to_interview_count')">
                מועמדים שעברו לסטטוס ראיון
                <span v-if="sortField === 'offer_to_interview_count'" class="sort-indicator">
                  {{ sortDirection === 'desc' ? '↓' : '↑' }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="employer in sortedEmployers" :key="employer.company_id">
              <td>
                <link-entity
                  :payload="getCompanyPayload(employer)"
                  :additional_data="{ resource_type: 'Company' }"
                />
              </td>
              <td>{{ employer.days_since_last_phone_call }}</td>
              <td>{{ employer.phone_calls_count }}</td>
              <td>{{ employer.submissions_count }}</td>
              <td>{{ employer.exposed_count }}</td>
              <td>{{ employer.company_familiar_count }}</td>
              <td>{{ employer.offer_to_interview_count }}</td>
            </tr>
          </tbody>
        </table>
        <div class="mt-4">
          <p class="has-text-grey">
            סה"כ {{ employers.length }} חברות ששלחנו להן מועמדים ב-30 הימים האחרונים
          </p>
        </div>
      </div>
      <div v-else-if="!loading">
        <p class="has-text-grey">לא נמצאו נתונים עבור 30 הימים האחרונים</p>
      </div>
    </div>
  </div>
</template>

<script>
import LinkEntity from '@/components/LinkEntity'

export default {
  name: 'EmployersLastMonth',
  components: {
    LinkEntity
  },
  data () {
    return {
      employers: [],
      loading: true,
      sortField: 'submissions_count',
      sortDirection: 'desc'
    }
  },
  computed: {
    sortedEmployers () {
      if (!this.sortField || !this.employers.length) return this.employers

      return [...this.employers].sort((a, b) => {
        let aVal = a[this.sortField]
        let bVal = b[this.sortField]

        // Handle string vs numeric sorting
        if (typeof aVal === 'string') {
          aVal = aVal.toLowerCase()
          bVal = bVal.toLowerCase()
        }

        const result = aVal < bVal ? -1 : aVal > bVal ? 1 : 0
        return this.sortDirection === 'desc' ? -result : result
      })
    }
  },
  created () {
    this.getEmployersLastMonth()
  },
  methods: {
    sortBy (field) {
      if (this.sortField === field) {
        // Toggle direction if same field
        this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc'
      } else {
        // New field, default to DESC as requested
        this.sortField = field
        this.sortDirection = 'desc'
      }
    },
    getEmployersLastMonth () {
      this.loading = true
      this.$network_utils.getEmployersLastMonth().then(response => {
        // Transform array of arrays to array of objects
        this.employers = response.map(row => ({
          company_id: row[0],
          company_name: row[1],
          submissions_count: row[2],
          exposed_count: row[3],
          company_familiar_count: row[4],
          offer_to_interview_count: row[5],
          phone_calls_count: row[6],
          days_since_last_phone_call: row[7]
        }))
        this.loading = false
      }).catch(error => {
        console.error('Error fetching employers last month data:', error)
        this.loading = false
      })
    },
    getCompanyPayload (employer) {
      return {
        resource_id: employer.company_id,
        user_id: employer.company_id,
        name: employer.company_name
      }
    }
  }
}
</script>

<style scoped>
.table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.table td {
  vertical-align: middle;
}

.sortable-header {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.sortable-header:hover {
  background-color: #e8e8e8;
}

.sort-indicator {
  margin-left: 5px;
  font-weight: bold;
  color: #3273dc;
}

.company-link {
  color: #3273dc;
  text-decoration: none;
  font-weight: 500;
}

.company-link:hover {
  color: #2366d1;
  text-decoration: underline;
}
</style>
